
import { Component, OnInit, HostListener } from '@angular/core';
import { ViewEncapsulation, ViewChild } from "@angular/core";
import { SwiperComponent } from "swiper/angular";
import data from '../../banner.json'

// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
import { Data } from '@angular/router';

// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: 'app-slide-banner',
  templateUrl: './slide-banner.component.html',
  styleUrls: ['./slide-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SlideBannerComponent implements OnInit {

  items = data.main
  mobile: boolean = false
  desktop?: boolean

  constructor() { }

  ngOnInit(): void {
    this.checkIsMobile()

  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIsMobile(); // Chama a verificação sempre que a janela for redimensionada
  }
  checkIsMobile() {
    const largura = window.screen.width;
    if (largura < 440) {
      this.mobile = true
    } else {
      this.desktop = true
      this.mobile = false
    }
  }
}
